/**
 * Condition
 */
class Condition {
  constructor({ id, logic, message, value }) {
    this.id = id;
    this.logic = logic;
    this.value = value;
  }

  get type() {
    if (this.logic === "[item_qty] >= [value]") return "qty";
    if (this.logic === "[paid_amount] >= [value]") return "total";
    if (this.logic === "[charge_amount] >= [value]") return "paid";
    return "undefined";
  }

  getType() {
    if (this.logic === "[item_qty] >= [value]") return "qty";
    if (this.logic === "[paid_amount] >= [value]") return "total";
    if (this.logic === "[charge_amount] >= [value]") return "paid";
    return "undefined";
  }

  getMessage(lan = "th-TH") {
    if (!this.logic) return "";
    if (!ConditionTextMap[this.logic][lan]) lan = "en-US";
    if (this.value === 0) return "";
    return ConditionTextMap[this.logic][lan].replace("[value]", this.value);
  }

  getPayloadData() {
    return {
      id: this.id,
      type: this.getType(),
      logic: this.logic,
    };
  }

  isPassCondition(qty, price, totalNoDiscount) {
    if (this.getType() === "qty") {
      return this.value <= qty;
    } else if (this.getType() === "paid") {
      return this.value <= price;
    } else if (this.getType() === "total") {
      return this.value <= totalNoDiscount;
    } else return true;
  }
}

const ConditionTextMap = {
  "[item_qty] >= [value]": {
    "th-TH": `ขั้นต่ำ [value] ชิ้น`,
    "en-US": `Min[value] units`,
  },
  "[paid_amount] >= [value]": {
    "th-TH": `ยอดหลังลด [value] บาท`,
    "en-US": `Min paid [value] THB`,
  },
  "[charge_amount] >= [value]": {
    "th-TH": `ยอด [value] บาท`,
    "en-US": `Min charge [value]THB`,
  },
  "[total_ltv] >= [value]": {
    "th-TH": `LTV [value] ขึ้นไป`,
    "en-US": `LTV over [value]`,
  },
  "[total_transaction] >= [value]": {
    "th-TH": `มี [value] รายการขึ้นไป`,
    "en-US": `All trans over [value]`,
  },
};

export default Condition;
